import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";

import {
  createUser,
  deleteUser,
  getUser,
  searchUser,
  updateUser,
} from "../../api/User";
import UserCard from "./UserCard";
import List from "../../components/List";
import EditUser from "./Edit";
import { useModal } from "../../context/ModalContext";

export default function Users() {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();

  const load = useCallback(() => {
    const search = async () => setData(await searchUser(query, all, page));
    search();
  }, [query, all, page]);

  useEffect(() => {
    load();
  }, [query, all, page, load]);

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              name: "",
              email: "",
              password: "",
              role: "USER",
              avatar: null,
            })
          }
          Item={(item) => (
            <UserCard
              key={"ku" + item.id}
              user={item}
              onEdit={async () => {
                const loaded = await getUser(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteUser(item);
                  load();
                } catch (e) {
                  showModal("O usuário não pode ser apagado", "warn", 10);
                }
              }}
            />
          )}
        />
      </Content>
      <EditUser
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (user) => {
          try {
            if (user.id) {
              await updateUser(user);
            } else {
              await createUser(user);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar usuário", "error", 10);
          }
        }}
      />
    </>
  );
}
